import React, { useState, useEffect } from "react";
import { Header } from "./Header";
import Sidebar from "./Sidebar";
import { axInst } from "./Login/Service.jsx";
import { useKeycloak } from "@react-keycloak/web";
import axios from "axios";
import Swal from "sweetalert2";

const Layout = ({ children, title, dashboardAlias }) => {
  const { keycloak } = useKeycloak();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    Swal.fire({
      title: "Do you want to logout?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Logout",
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const basicAuth =
            "Basic " +
            btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

          // Log user logout action
          await axInst.post(
            `${process.env.REACT_APP_API_URL}user-system-logs`,
            {},
            { withCredentials: true },
          );

          // Logout from backend (cookie-based)
          await axios.post(
            `${process.env.REACT_APP_API_URL}logout`,
            {},
            {
              headers: { Authorization: basicAuth },
              withCredentials: true, // send HttpOnly cookie to backend
            },
          );

          // Clear any non-sensitive session data
          sessionStorage.clear();

          // Keycloak logout
          keycloak.logout({ redirectUri: window.location.origin });
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  // Check for authenticated session via backend cookie
  useEffect(() => {
    const checkSession = async () => {
      try {
        await axInst.get("user-profile"); // protected endpoint
      } catch (err) {
        // If request fails, logout
        keycloak.logout({ redirectUri: window.location.origin });
      }
    };
    checkSession();
  }, [keycloak]);

  return (
    <div className="flex flex-row min-h-screen bg-[#f2f5f9]">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      <div className="flex flex-col flex-grow">
        <Header
          handleLogout={handleLogout}
          title={title}
          dashboardAlias={dashboardAlias}
          setMobileOpen={setMobileOpen}
        />
        <main className="main-content flex flex-col flex-1 ">
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, { mobileOpen });
            }
            return child;
          })}
        </main>
      </div>
    </div>
  );
};

export default Layout;
